import axios from "axios";
import ContractHostel from '../../../components/application/statement_hostel/Services/Api/Pichers/ContractHostel'
import store from "../index.js.erb";


const FormingContractHostel = {
    namespaced: true,
    state: {
        identity_card: {},
        error_flag: false
    },
    getters: {
    },
    mutations: {
        setIdentityCard(state, identity_card){
            state.identity_card = identity_card
        },
        setErrorFlag(state, error_flag){
            state.error_flag = error_flag
        }
    },
    actions: {
        async GetIdentityCard({state, commit}){
            await axios({
                method: 'get',
                url: '/statement_hostel/pichers/identity_cards/get_identity_card',
            }).then((response) => {
                commit('setIdentityCard', response.data);
                commit('setErrorFlag', false);
            }).catch((error) => {
                commit('setErrorFlag', true);
                return error
            })
        },
        async CreateHostelContract({state, commit}, data_contract){
            const response = await ContractHostel.create(data_contract)
            await store.dispatch("interactionStatement/ShowStatement")
        },
        async UpdateHostelContract({state, commit}, data_contract){
            const response = await ContractHostel.update(data_contract)
            await store.dispatch("interactionStatement/ShowStatement")
        },

    }
}

export default FormingContractHostel